// Реализация модального окна
import GraphModal from 'graph-modal';
const modal = new GraphModal();
